// extracted by mini-css-extract-plugin
export default {"bar":"verification_bar__iQOu6","progress":"verification_progress__u5HUE","alert":"verification_alert__Gpu0E","verifyButton":"verification_verifyButton__UUn1A"};